import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {platformBrowser} from '@angular/platform-browser';

// Forces amCharts4's internal class hierarchy (Base -> Interaction/System/Container/Sprite -> Popup ->
// Modal) to evaluate as part of the eager main bundle instead of a lazily-loaded chunk. amCharts4 has a
// genuine circular dependency internally (Animation -> System -> Container -> Sprite -> Animation), and
// under the esbuild-based application builder, splitting that connected component across a dynamic
// import() boundary shared by multiple lazy routes (resources + sectors) breaks evaluation order with
// "Class extends value undefined is not a constructor or null". Webpack tolerated this; esbuild/Rollup's
// ESM chunk splitting does not. Costs ~102 kB (gzip) on every initial load - see PR description.
import '@amcharts/amcharts4/core';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(AppModule, {applicationProviders: [provideZoneChangeDetection()]})
  .catch(err => console.error(err));
